import React, { useState, useEffect } from 'react';
import { useApp } from '../context/AppContext';
import { getAdminProfile, updateAdminPassword } from '../services/api';
import './Profile.css';

export default function Profile({ toast }) {
  const { token, auth, logout } = useApp();
  const [profile,   setProfile]   = useState(null);
  const [loading,   setLoading]   = useState(true);
  const [currentPw, setCurrentPw] = useState('');
  const [newPw,     setNewPw]     = useState('');
  const [confirmPw, setConfirmPw] = useState('');
  const [pwLoading, setPwLoading] = useState(false);
  const [error,     setError]     = useState('');
  const [saved,     setSaved]     = useState(false);

  useEffect(() => {
    let cancelled = false;
    getAdminProfile(token)
      .then(res => { if (!cancelled) setProfile(res.data); })
      .catch(() => {})
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [token]);

  const updatePw = async () => {
    if (!currentPw || !newPw || !confirmPw) { setError('All fields are required'); return; }
    if (newPw.length < 8) { setError('New password must be at least 8 characters'); return; }
    if (newPw !== confirmPw) { setError('Passwords do not match'); return; }
    setError(''); setPwLoading(true);
    try {
      await updateAdminPassword(token, currentPw, newPw);
      setSaved(true);
      setCurrentPw(''); setNewPw(''); setConfirmPw('');
      toast?.('Password updated successfully');
      setTimeout(() => setSaved(false), 3000);
    } catch (e) {
      setError(e.message || 'Failed to update password');
    } finally {
      setPwLoading(false);
    }
  };

  const displayEmail = profile?.email || auth?.email || '—';
  const initials = displayEmail.slice(0, 2).toUpperCase();
  const createdAt = profile?.createdAt ? new Date(profile.createdAt).toLocaleDateString('en-GB', { day:'numeric', month:'long', year:'numeric' }) : '—';

  return (
    <div className="profile-page">
      {/* Profile card */}
      <div className="card profile-card">
        <div className="profile-avatar-row">
          <div className="profile-avatar">{initials}</div>
          <div>
            <div className="profile-name">{displayEmail}</div>
            <div className="profile-role"><span className="badge badge-blue">Super Admin</span></div>
          </div>
        </div>
        {!loading && (
          <div className="profile-details">
            {[
              ['Email',   displayEmail],
              ['Account created', createdAt],
              ['Admin ID', profile?.id ? profile.id.slice(0, 16) + '…' : '—'],
            ].map(([k,v]) => (
              <div key={k} className="profile-row">
                <span className="profile-key">{k}</span>
                <span className="profile-val">{v}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Change password — wired to real API */}
      <div className="card">
        <div className="card-header"><span className="card-title">Update password</span></div>

        {saved && <div className="success-banner">✓ Password updated successfully</div>}
        {error && <div className="error-banner">⚠ {error}</div>}

        <div className="pw-form">
          {[
            ['Current password', currentPw, setCurrentPw, 'Current password'],
            ['New password',     newPw,     setNewPw,     'New password (min 8 characters)'],
            ['Confirm password', confirmPw, setConfirmPw, 'Confirm new password'],
          ].map(([label, val, setter, placeholder]) => (
            <div key={label} className="pw-field">
              <label>{label}</label>
              <input type="password" placeholder={placeholder} value={val}
                onChange={e => setter(e.target.value)} className="search-input" />
            </div>
          ))}
          <button className="btn btn-primary" style={{ alignSelf:'flex-start', marginTop:4 }}
            onClick={updatePw} disabled={pwLoading}>
            {pwLoading ? 'Updating…' : 'Update password'}
          </button>
        </div>
      </div>

      {/* Danger zone */}
      <div className="card danger-card">
        <div className="card-header"><span className="card-title" style={{ color:'#ff4d4d' }}>Danger zone</span></div>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
          <div>
            <div style={{ fontSize:13, fontWeight:500, color:'var(--text-primary)', marginBottom:4 }}>Sign out</div>
            <div style={{ fontSize:12, color:'var(--text-muted)' }}>Clears your session and returns to login</div>
          </div>
          <button className="btn btn-danger" onClick={logout}>Sign out</button>
        </div>
      </div>
    </div>
  );
}
